// App Imports
import params from '../../../setup/config/params'
import {IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import List from '../List'
import bookingSetting from '../bookingSetting'
import { defaultImage } from '../../common/Sidebar';


// Image
export function getImageSource(image = defaultImage) {
  return `${ IMAGE_SOURCE_PATH }${ image }`
}

// Pages routes
const routes = {
  bookingsList: {
    path: '/table-bookings',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "tableReservation",
    action: "canView",
  },
  bookingSettings: {
    path: '/table-bookings/settings',
    component: bookingSetting,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "tableReservation",
    action: "canView",
  },
  
}
export default routes;